module.exports = __webpack_public_path__ + "bc480772e0592495db0575c9426cd81c.png";